import React from "react";

import Home from "../pages/Home/Home";

import { Switch, Route } from "react-router-dom";
import "./MainComponent.css";
import MainMethodsContainer from "../pages/Methods/MainMethodsContainer";
import GridTable from "../components/GridTable";

const MainComponent = () => {
  return (
    <div className="main-component-container">
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/methods" component={MainMethodsContainer} />
      </Switch>
    </div>
  );
};

export default MainComponent;
